import { render } from "./TutorialFab.vue?vue&type=template&id=48120271&scoped=true"
import script from "./TutorialFab.vue?vue&type=script&lang=js"
export * from "./TutorialFab.vue?vue&type=script&lang=js"

import "./TutorialFab.vue?vue&type=style&index=0&id=48120271&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48120271"]])

export default __exports__